export const APP_VERSION = import.meta.env.PACKAGE_VERSION;
export const DISCORD_LINK = "https://github.com/mathewbushuru/simple-proxy";
export const GITHUB_LINK = "https://github.com/mathewbushuru/simple-proxy";
export const DONATION_LINK = "https://github.com/mathewbushuru/simple-proxy";
export const GA_ID = import.meta.env.VITE_GA_ID;
export const BACKEND_URL = "https://mathewbushuru.com";
